<div class="form-group">
  <label [title]="titleText">
    <span>Format / Variant / Version</span>
    @if (!searchObject?.distributionObjectId) {
      <span> [Document type]</span>
    }
    @if (!direction) {
      <span> [Direction]</span>
    }
    @if (showConfigLinks) {
      <ep-document-config-links [documentConfigId]="selectedDocumentConfig?.DocumentConfigId"></ep-document-config-links>
    }
  </label>
  <select class="form-control" [(ngModel)]="selectedDocumentConfig" (ngModelChange)="documentConfigChanged($event)">
    @if (showAllOption) {
      <option [ngValue]="null">{{showAllOptionText}}</option>
    }
    @for (docConfig of documentConfigs; track docConfig) {
      <option [title]="docConfig.Description ?? ''" [ngValue]="docConfig">
        <span>{{docConfig.DisplayName}}</span>
        @if (!direction) {
          <span> [{{docConfig.Direction}}]</span>
        }
      </option>
    }
  </select>
</div>
